/**
 *  map status Tabs in myBets according to setttings
 */

export default class MyBetsTabsService {
  static tabs = {
    negotiation: { name: 'Mobile.negotiationshort', code: -2 },
    all: { name: 'Mobile.all', code: -1 },
    placed: { name: 'BetSlipStatusType.Placed', code: 0 },
    won: { name: 'BetSlipStatusType.Won', code: 1 },
    lost: { name: 'BetSlipStatusType.Lost', code: 2 },
    canceled: { name: 'BetSlipStatusType.Cancelled', code: 3 },
    pending: { name: 'BetSlipStatusType.Pending', code: 4 },
    paid: { name: 'BetSlipStatusType.Paid', code: 7 },
    void: { name: 'BetSlipStatusType.Void', code: 9 },
    halfwon: { name: 'BetSlipStatusType.HalfWon', code: 10 },
    halflost: { name: 'BetSlipStatusType.HalfLost', code: 11 },
    cashedout: { name: 'BetSlipStatusType.CachedOut', code: 12 },
    rejected: { name: 'BetSlipStatusType.Rejected', code: 5 },
    jackpotwon: { name: 'BetSlipStatusType.JackpotWon', code: 13 },
    jackpotlost: { name: 'BetSlipStatusType.JackpotLost', code: 14 },
    cashback: { name: 'BetSlipStatusType.CashBack', code: 15 },
  }

  static tabsWithSubTabs = [
    { key: 'placed', name: 'BetSlipStatusType.Placed', code: 0 },
    {
      key: 'settled',
      name: 'M.Settled',
      code: 1,
      tabs: [
        { key: 'won', name: 'BetSlipStatusType.Won', code: 1 },
        { key: 'lost', name: 'BetSlipStatusType.Lost', code: 2 },
        { key: 'canceled', name: 'BetSlipStatusType.Cancelled', code: 3 },
        { key: 'paid', name: 'BetSlipStatusType.Paid', code: 7 },
        { key: 'void', name: 'BetSlipStatusType.Void', code: 9 },
        { key: 'halfwon', name: 'BetSlipStatusType.HalfWon', code: 10 },
        { key: 'halflost', name: 'BetSlipStatusType.HalfLost', code: 11 },
        { key: 'cashedout', name: 'BetSlipStatusType.CachedOut', code: 12 },
        { key: 'rejected', name: 'BetSlipStatusType.Rejected', code: 5 },
        { key: 'cashback', name: 'BetSlipStatusType.CashBack', code: 15 },
      ]
    }
  ]

  static getOrderedTabs(statuses = '') {
    const tabList = statuses || APP_SETTINGS.myBets.orderedTabs;
    if (typeof tabList === 'undefined' || tabList === '') {
      return Object.entries(this.tabs).map(([key, val]) => ({
        ...val,
        key
      }));
    }
    const TabKeys = tabList.split(',');
    const availableTabs = [];
    TabKeys.forEach((tabKey) => {
      if (typeof this.tabs[tabKey.trim()] !== 'undefined') {
        availableTabs.push({ ...this.tabs[tabKey.trim()], key: tabKey.trim() });
      }
    });
    return availableTabs;
  }
  /**
   * returns an array of all statuses used for "ALL" tab.
   */
  static getOrderedTabCodes() {
    const orderedTabs = this.getOrderedTabs(APP_SETTINGS.myBets.AllTabStatuses).map(tab => tab.code).filter(s => s > -1);
    return orderedTabs;
  }

  static getSubTabs() {
    const tabList = APP_SETTINGS.myBets.orderedTabs;
    // if tab config is not present ship with default values
    if (!tabList) {
      return this.tabsWithSubTabs;
    }
    const tabKeys = tabList.split(',').map(k => k.trim());
    // show main tab only if the main tab or any of it's sub tabs have tab key from conifg
    const filteredMainTabs = this.tabsWithSubTabs
      .filter(tab => tab.tabs ? tab.tabs.some(st => tabKeys.some(k => k === st.key)) : tabKeys.some(k => k === tab.key));
    const mappedTabs = filteredMainTabs.map((tab) => {
      // if main tab doesn't have sub tabs return the tab
      if (!tab.tabs) {
        return tab;
      }
      // filter and order subs tabs as they are in config
      let filteredTabs = tabKeys.filter(ot => tab.tabs.some(t => t.key === ot)).map(ot => ({ ...this.tabs[ot], key: ot }));
      // add all tab for the sub tabs and push it at start position
      const allTab = { key: `all_${tab.key}`, name: 'Mobile.all', code: -10, tabCodes: filteredTabs.map(t => t.code) };
      filteredTabs.unshift(allTab);

      const dTabKey = (APP_SETTINGS.myBets.defaultTab || '').trim();
      // if we have default tab config try to find it from sub tabs and set it as default for main tab otherwise set first sub tab as default
      const defaultTab = filteredTabs.find(ft => ft.key === dTabKey) || filteredTabs[0];

      return {
        key: tab.key,
        name: tab.name,
        code: defaultTab.code,
        // only needed when default tab is allTab
        tabCodes: defaultTab.tabCodes,
        tabs: filteredTabs
      };
    });

    return mappedTabs;
  }
}
